import type { ObraPlanDb, OutboxRow } from './db';

/** A fila da Conferência no banco do aparelho (Fase 43, RN-603). */
export interface OutboxStore {
  /** As operações de quem fez, na ordem em que foram feitas. */
  all(userId: string): Promise<OutboxRow[]>;
  get(id: string): Promise<OutboxRow | undefined>;
  put(row: OutboxRow): Promise<void>;
  delete(id: string): Promise<void>;
}

export class DexieOutboxStore implements OutboxStore {
  constructor(private readonly db: ObraPlanDb) {}

  all(userId: string): Promise<OutboxRow[]> {
    return this.db.outbox.where('userId').equals(userId).sortBy('seq');
  }

  get(id: string): Promise<OutboxRow | undefined> {
    return this.db.outbox.get(id);
  }

  async put(row: OutboxRow): Promise<void> {
    await this.db.outbox.put(row);
  }

  async delete(id: string): Promise<void> {
    await this.db.outbox.delete(id);
  }
}
